import { IFilter, IFilterOption } from '../../interfaces/Filter.interfaces';
import { filterSliderConstant } from './slider/filterSliderConstant';

export interface IDirectDealFilterOption extends IFilterOption {
  value: DirectDealFilterOptionValueType;
  description?: string;
}

export type directDealFilterKeyType =
  | 'sorter'
  | 'filter_brand'
  | 'engineOutputInPs'
  | 'price'
  | 'status'
  | 'machineType'
  | 'rowConfig'
  | 'operationTime';

export interface IDirectDealFilter extends IFilter {
  key: directDealFilterKeyType;
  options: IDirectDealFilterOption[];
}

export enum DirectDealFilterOptionValueSorterEnum {
  default_desc = 'default_desc',
  operationTime_asc = 'operationTime_asc',
  price_desc = 'price_desc',
  engineOutputInPs_desc = 'engineOutputInPs_desc',
}

type DirectDealFilterOptionValueType = DirectDealFilterOptionValueSorterEnum | string | number;

const directDealFilterSorterConstant: IDirectDealFilter = {
  key: 'sorter',
  title: '정렬',
  optionType: 'radio',
  options: [
    {
      optionName: '기본 정렬순',
      optionNameForButton: '기본순으로 보기',
      value: DirectDealFilterOptionValueSorterEnum.default_desc,
      isDefault: true,
      isSelected: true,
    },
    {
      optionName: '사용시간순',
      optionNameForButton: '사용시간순으로 보기',
      value: DirectDealFilterOptionValueSorterEnum.operationTime_asc,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '가격순',
      optionNameForButton: '가격순으로 보기',
      value: DirectDealFilterOptionValueSorterEnum.price_desc,
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '마력(조식)순',
      optionNameForButton: '마력(조식)순으로 보기',
      value: DirectDealFilterOptionValueSorterEnum.engineOutputInPs_desc,
      isDefault: false,
      isSelected: false,
    },
  ],
};

const directDealFilterPriceConstant: IDirectDealFilter = {
  key: 'price',
  title: '가격',
  buttonTitle: '가격으로 보기',
  optionType: 'slider',
  options: [
    {
      optionName: 'min',
      value: filterSliderConstant.price.min,
      defaultValue: filterSliderConstant.price.min,
      isSelected: true,
    },
    {
      optionName: 'max',
      value: filterSliderConstant.price.max,
      defaultValue: filterSliderConstant.price.max,
      isSelected: true,
    },
  ],
};

const directDealFilterEngineOutputInPsConstant: IDirectDealFilter = {
  key: 'engineOutputInPs',
  title: '마력',
  buttonTitle: '마력 · 조식으로 보기',
  optionType: 'slider',
  options: [
    {
      optionName: 'min',
      value: filterSliderConstant.engineOutputInPs.min,
      defaultValue: filterSliderConstant.engineOutputInPs.min,
      isSelected: true,
    },
    {
      optionName: 'max',
      value: filterSliderConstant.engineOutputInPs.max,
      defaultValue: filterSliderConstant.engineOutputInPs.max,
      isSelected: true,
    },
  ],
};

const directDealFilterOperationTimeConstant: IDirectDealFilter = {
  key: 'operationTime',
  title: '사용시간',
  buttonTitle: '사용시간으로 보기',
  optionType: 'slider',
  options: [
    {
      optionName: 'min',
      value: filterSliderConstant.operationTime.min,
      defaultValue: filterSliderConstant.operationTime.min,
      isSelected: true,
    },
    {
      optionName: 'max',
      value: filterSliderConstant.operationTime.max,
      defaultValue: filterSliderConstant.operationTime.max,
      isSelected: true,
    },
  ],
};

const directDealFilterStatusConstant: IDirectDealFilter = {
  key: 'status',
  title: '판매 상태',
  optionType: 'radio',
  options: [
    {
      optionName: '판매중',
      optionNameForButton: '판매중만 보기',
      value: 'ONSALE',
      isDefault: true,
      isSelected: true,
    },
    {
      optionName: '판매완료',
      optionNameForButton: '판매완료만 보기',
      value: 'SOLDOUT',
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '전체',
      optionNameForButton: '판매중 · 판매완료 보기',
      value: 'ALL',
      isDefault: false,
      isSelected: false,
    },
  ],
};

const directDealFilterBrandConstant: IDirectDealFilter = {
  key: 'filter_brand',
  title: '브랜드',
  buttonTitle: '브랜드로 보기',
  optionType: 'checkbox',
  options: [],
};

const directDealFilterMachineTypeConstant: IDirectDealFilter = {
  key: 'machineType',
  title: '분류',
  optionType: 'radio',
  options: [
    {
      optionName: '전체',
      optionNameForButton: '트랙터 · 콤바인 보기',
      value: 'ALL',
      isDefault: true,
      isSelected: true,
    },
    {
      optionName: '트랙터',
      optionNameForButton: '트랙터만 보기',
      value: 'tractor',
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '콤바인',
      optionNameForButton: '콤바인만 보기',
      value: 'combine',
      isDefault: false,
      isSelected: false,
    },
  ],
};

const directDealFilterRowConfigConstant: IDirectDealFilter = {
  key: 'rowConfig',
  title: '조식',
  optionType: 'checkbox',
  options: [
    {
      optionName: '2~4조식',
      value: '2_4',
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '5~8조식',
      value: '5_8',
      isDefault: false,
      isSelected: false,
    },
    {
      optionName: '보통형',
      value: 'common',
      isDefault: false,
      isSelected: false,
    },
  ],
};

export const directDealFiltersConstant: IDirectDealFilter[] = [
  directDealFilterMachineTypeConstant,
  directDealFilterBrandConstant,
  directDealFilterEngineOutputInPsConstant,
  directDealFilterRowConfigConstant,
  directDealFilterOperationTimeConstant,
  directDealFilterPriceConstant,
  directDealFilterSorterConstant,
  directDealFilterStatusConstant,
];
